import React from 'react';
import PrivateRoute from './PrivateRoute';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Login } from '../pages/login';
import { ResetPassword } from '../pages/reset-password';
import { ForgotPassword } from '../pages/forgot-password';
import { Dashboard } from '../pages/dashboard';
import { Orders } from '../pages/orders';
import { SendDanfeXML } from '../pages/send-danfe-xml';
import { OrderDetail } from '../pages/order-detail';
import { Profile } from '../pages/profile';
import { Boletos } from '../pages/boletos';
import { Logs } from '../pages/logs';
import { UsersLogs } from '../pages/users-logs';
import { LogsPanel } from '../models/components/logs-panel';
import { ProfileLogs } from '../pages/profile-logs';
import { Comissionamento } from '../pages/Commissioning/Commissioning';
import { ScreeningSignup } from '../pages/Signup/Screening';
import { CollaboratorSignup } from '../pages/Signup/CollaboratorSignup/CollaboratorSignup';
import { DealerSignup } from '../pages/Signup/DealerSignup/DealerSignup';
import { DealerCompleteStep } from '../pages/Signup/DealerSignup/Components/Steps/DealerCompleteStep';
import { AccessTabNavigation } from '../pages/AccessControl/Components/AccessTabNavigation';
import { Users } from '../pages/AccessControl/Users/Users';
import { Permissions } from '../pages/AccessControl/Permissions/Permissions';
import { ActivityHistory } from '../pages/AccessControl/ActivityHistory';
import { NewUsers } from '../pages/AccessControl/Users/NewUsers';
import { ShippingLogs } from '../pages/ShippingLogs/ShippingLogs';
import { NewDealers } from '../pages/DealerControl/Dealers/NewDealers';
import { Dealers } from '../pages/DealerControl/Dealers/Dealers';
import { DealerTabNavigation } from '../pages/DealerControl/Components/DealerTabNavigation';
import { Users as TeamUsers } from '../pages/AcessControlTeam/TeamManager/Users';
import { NewUsers as NewUsersTeam } from '../pages/AcessControlTeam/Users/NewUsers';
import { Permissions as PermissionsTeam } from '../pages/AcessControlTeam/Permissions/Permissions';
import { ActivityHistory as ActivityHistoryTeam } from '../pages/AcessControlTeam/ActivityHistory';
import { AccessTabNavigation as AccessTabNavigationTeam } from '../pages/AcessControlTeam/Components/AccessTabNavigation';
import { Users as UsersTeam } from '../pages/AcessControlTeam/Users/Users';

function Router() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/esqueci-a-senha" element={<ForgotPassword />} />
      <Route path="/resetar-senha" element={<ResetPassword />} />
      <Route path="/cadastro/perfis" element={<ScreeningSignup />} />
      <Route path="/cadastro/colaborador" element={<CollaboratorSignup />} />
      <Route path="/cadastro/revendedor" element={<DealerSignup />} />
      <Route path="/cadastro/concluido" element={<DealerCompleteStep />} />
      <Route path="*" element={<Navigate replace to="/" />} />

      <Route
        element={<PrivateRoute requiredRoles={['GDU']} />}
        path="/controle-de-acesso"
      >
        <Route element={<AccessTabNavigation />}>
          <Route
            path="novos-usuarios"
            element={<NewUsers setTotalEmAnalise={() => null} />}
          />
          <Route path="usuarios" element={<Users />} />
          <Route path="historico-de-atividades" element={<ActivityHistory />} />
          <Route path="perfis" element={<Permissions />} />
        </Route>
      </Route>

      <Route
        element={<PrivateRoute requiredRoles={['GDR']} />}
        path="/gestao-de-revendas"
      >
        <Route element={<DealerTabNavigation />}>
          <Route
            path="novos-revendedores"
            element={<NewDealers setTotalEmAnalise={() => null} />}
          />
          <Route path="revendedores" element={<Dealers />} />
          <Route path="historico-de-atividades" element={<ActivityHistory />} />
        </Route>
      </Route>

      <Route element={<PrivateRoute requiredRoles={['CDL']} />} path="/logs">
        <Route element={<LogsPanel />}>
          <Route path="consulta" element={<Logs />} />
          <Route path="usuarios" element={<UsersLogs />} />
          <Route path="perfis" element={<ProfileLogs />} />
          <Route path="envios" element={<ShippingLogs />} />
        </Route>
      </Route>

      <Route element={<PrivateRoute requiredRoles={['CDP']} />}>
        <Route path="/pedidos" element={<Orders />} />
        <Route path="/pedido/:id" element={<OrderDetail />} />
      </Route>

      <Route element={<PrivateRoute requiredRoles={['EDX']} />}>
        <Route path="/envio-danfe-xml" element={<SendDanfeXML />} />
      </Route>

      <Route element={<PrivateRoute requiredRoles={['PDB']} />}>
        <Route path="/boletos" element={<Boletos />} />
      </Route>

      <Route element={<PrivateRoute />}>
        <Route path="/painel" element={<Dashboard />} />
        <Route path="/perfil" element={<Profile />} />
      </Route>

      <Route
        element={
          <PrivateRoute requiredRoles={['USR', 'ADM', 'CDP', 'GDU', 'CDC']} />
        }
      >
        <Route path="/comissionamento" element={<Comissionamento />} />
      </Route>

      <Route
        element={<PrivateRoute requiredRoles={['GDE']} />}
        path="/gestao-de-equipe"
      >
        <Route element={<AccessTabNavigationTeam />}>
          <Route index element={<Navigate to="equipe" replace />} />
          <Route path="equipe" element={<UsersTeam />} />
          <Route path="usuarios" element={<UsersTeam />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default Router;
